import React, { useEffect, useState } from "react";
import { useParams, Navigate } from "react-router-dom";
import api from "@/lib/api";
import SchoolDetail from "@/pages/public/SchoolDetail";

// Slug-based route: /s/:slug → resolves to school ID and reuses SchoolDetail
export default function SchoolBySlug() {
  const { slug } = useParams();
  const [id, setId] = useState(null);
  const [err, setErr] = useState(false);
  useEffect(() => {
    api.get(`/schools/by-slug/${slug}`).then((r) => setId(r.data.id)).catch(() => setErr(true));
  }, [slug]);
  if (err) return <Navigate to="/schools" replace />;
  if (!id) return <div className="p-10 text-slate-500">Loading…</div>;
  return <SchoolDetail overrideId={id} />;
}
